import cls from "classnames";
import { settings } from "imagica-corekit/dist/base/kernel/Settings";
import prettyBytes from "pretty-bytes";
import styles from "./UploadLoading.module.scss";
import React from "react";
import { NodesUtil } from "../NodesUtil";
import { LoadingOutline } from "../../components/LoadingOutline/LoadingOutline";
import { isNaN } from "lodash";
var NO_PREVIEW_TIP_TEXT = "There is no preview available for this file, but you can still connect an edge from this node.";
export function UploadLoading(_ref) {
  var fileName = _ref.fileName,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 0 : _ref$size,
    _ref$errorMsg = _ref.errorMsg,
    errorMsg = _ref$errorMsg === void 0 ? "" : _ref$errorMsg,
    _ref$percent = _ref.percent,
    _ref$percent2 = _ref$percent === void 0 ? {
      loaded: 0,
      total: 0
    } : _ref$percent,
    loaded = _ref$percent2.loaded,
    total = _ref$percent2.total,
    onClose = _ref.onClose,
    loading = _ref.loading,
    unStructuredDownloadFailedText = _ref.unStructuredDownloadFailedText,
    isInCanvas = _ref.isInCanvas,
    isStaticApp = _ref.isStaticApp;
  var wrapCls = cls(styles.wrap, errorMsg && styles.infoError, loading === "finish" && styles.infoSuccess);
  var fileFormat = fileName === null || fileName === void 0 ? void 0 : fileName.split(".").last();
  var fileIconStr = "Files";
  if (fileFormat === "txt") {
    fileIconStr = "txt";
  } else if (fileFormat === "wav") {
    fileIconStr = "wav";
  }
  var fileSize = !NodesUtil.isEmpty(errorMsg) ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("img", {
    src: "".concat(settings.S3CDN).concat(settings.viewAssetsPath, "close_red.svg"),
    alt: ""
  }), " ", /*#__PURE__*/React.createElement("span", null, prettyBytes(size))) : !NodesUtil.isEmpty(loading) ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("img", {
    src: "".concat(settings.S3CDN).concat(settings.viewAssetsPath, "upload_success.svg"),
    alt: ""
  }), " ", /*#__PURE__*/React.createElement("span", null, "Uploaded /"), /*#__PURE__*/React.createElement("span", {
    className: styles.size
  }, prettyBytes(size))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, prettyBytes(loaded)), " ", /*#__PURE__*/React.createElement("span", null, "/"), " ", /*#__PURE__*/React.createElement("span", {
    className: styles.size
  }, prettyBytes(size)));
  var uploadProcess = Math.round(loaded / total * 100);
  if (isNaN(uploadProcess)) {
    uploadProcess = 0;
  }
  var uploadProcessStr = uploadProcess.toFixed(2);
  return /*#__PURE__*/React.createElement("div", {
    className: cls(styles.uploadLoading, NodesUtil.constants.NO_WHEEL, "nopan")
  }, /*#__PURE__*/React.createElement("div", {
    className: wrapCls
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.info
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.infoLeft
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.icon
  }, /*#__PURE__*/React.createElement("img", {
    src: "".concat(settings.S3CDN).concat(settings.viewAssetsPath).concat(fileIconStr, ".svg"),
    alt: ""
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.fileName
  }, fileName), /*#__PURE__*/React.createElement("div", {
    className: styles.fileSize
  }, fileSize))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles.operation, " ").concat(isStaticApp && !isInCanvas ? styles.closeHidden : null)
  }, /*#__PURE__*/React.createElement("span", null), /*#__PURE__*/React.createElement("img", {
    onClick: onClose,
    src: "".concat(settings.S3CDN).concat(settings.viewAssetsPath, "close_black.svg"),
    alt: ""
  }))), NodesUtil.isEmpty(errorMsg) && NodesUtil.isEmpty(loading) && !unStructuredDownloadFailedText && /*#__PURE__*/React.createElement("div", {
    className: styles.progressBar
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: "".concat(uploadProcessStr, "%")
    }
  }))), isInCanvas === true && /*#__PURE__*/React.createElement(React.Fragment, null, NodesUtil.isEmpty(errorMsg) && !NodesUtil.isEmpty(loading) && /*#__PURE__*/React.createElement("div", {
    className: styles.indexerResult
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.irTitle
  }, NO_PREVIEW_TIP_TEXT), /*#__PURE__*/React.createElement("div", {
    className: styles.irContent
  }, loading === "pending" && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", null, "Generating a summary..."), /*#__PURE__*/React.createElement(LoadingOutline, {
    className: styles.LoadingSty
  })), unStructuredDownloadFailedText && /*#__PURE__*/React.createElement("div", null, unStructuredDownloadFailedText)))), !NodesUtil.isEmpty(errorMsg) && /*#__PURE__*/React.createElement("div", {
    className: styles.errorMsg
  }, errorMsg));
}